import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const createUnstyledPluginButton = ({
  text
}) => {
  const UnstyledTextButton = ({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      children: text
    });
  };
  return UnstyledTextButton;
};
export default createUnstyledPluginButton;